module.exports = __webpack_public_path__ + "static/screen-img-0bf6b4900a3c0cb18c836fbd02330300.png";